/**
 * Notifications React Query Hooks
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { clearNotification, listNotifications } from '../lib/api/notifications.client';
import { config } from '../lib/config';
const NOTIFICATIONS_POLL_INTERVAL_MS = 60000;
/**
 * Current user's unread notifications, polled so the bell stays fresh.
 */
export function useUnreadNotifications() {
    return useQuery({
        queryKey: ['notifications', 'unread'],
        queryFn: () => listNotifications('unread'),
        // Notifications API may not be configured in all environments yet
        enabled: Boolean(config.api.notifications),
        refetchInterval: NOTIFICATIONS_POLL_INTERVAL_MS,
        refetchOnWindowFocus: true,
        retry: 1,
    });
}
/**
 * Clear a notification (removes it from the bell).
 */
export function useClearNotification() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (notificationId) => clearNotification(notificationId),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ['notifications'] });
        },
    });
}
